export default "__VITE_PUBLIC_ASSET__c8ad87aa__"